module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-arrow-down-9785f978.svg";